import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type ExternalTextLinkTargetProperties = {
  clickref: string;
  destination_url: string;
  retailer_id?: string;
};

type EventData = {
  clickref: string;
  destinationUrl: string;
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  retailerId?: string;
};

class ExternalTextLinkInteractionEvent extends InteractionEvent<
  EventData,
  ExternalTextLinkTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'external_text_link';
  }

  protected getTargetProperties(): ExternalTextLinkTargetProperties {
    return {
      clickref: this.data.clickref,
      destination_url: this.data.destinationUrl,
      retailer_id: this.data.retailerId
    };
  }
}

export default ExternalTextLinkInteractionEvent;
